import { Resource } from "../resource";


export class Training extends Resource {
    name: string
    videoId: string
    
}